import React, { useEffect, useRef, useState } from 'react'
import { Form, Row, Col, Button, Spinner, InputGroup, Card } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { IMPSOCIALGOALAction } from '../../../Reducer/ImportSocialGoalsReducer';
import { IMPPERSONALGOALAction } from '../../../Reducer/ImportPersonalGoalsReducer';
import { IMPPROFESSIONALGOALAction } from '../../../Reducer/ImportProfessionalGoalsReducer';
import { IMPHEALTHSAFEGOALAction } from '../../../Reducer/ImportHealthSafeGoalsReducer';
import Icon from '../../controls/Icons/Icon';

export default function PCPGoalTypeModal({_inputValue,_ClientId,_ClientName, afterSave,  onCancel }) {
    const state = useSelector(state => state);
    const [loading, setLoading] = useState(false);
    const [Data,setData] = useState([]);
    const [DeletedGoalType,setDeletedGoalType] = useState("");
    const [socialGoals,setsocialGoals] = useState([]);
    const [personalGoals,setPersonalGoals] = useState([]);
    const [professionalGoals,setprofessionalGoals] = useState([]);
    const [healthandSafetyGoals, sethealthandSafetyGoals] = useState([]);
    const [dataLoaded, setdataLoaded] = useState(false);
    const [selectedSocialGoals, setselectedSocialGoals] = useState([]);
    const [selectedpersonalGoals, setselectedpersonalGoals] = useState([]);
    const [selectedprofessionalGoals, setselectedprofessionalGoals] = useState([]);
    const [selectedhealthandSafetyGoals, setselectedhealthandSafetyGoals] = useState([]);
    const [socialAction,setsocialAction] = useState([]);
    const [personalAction,setPersonalAction] = useState([]);
    const [professionalAction,setprofessionalAction] = useState([]);
    const [healthandSafetyAction, sethealthandSafetyAction] = useState([]);
    const [selectAll,setSelectAll] = useState(false);
    const dispatch = useDispatch();
    const [disableImportBtn, setdisableImportBtn] = useState(false);
   
    const [loadCnt,setloadCnt]=useState(0);
    let today = new Date()
    const [inputValue, setInputValue] = useState({
       // DOB:null,
        FirstName: "",
        LastName: "",
        UCINumber:"",
        MotherName: "",
        UserId:0,
        FatherName:"",
        CreatedBy:""
    });
    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            const res = await fetch(state.projectdetail.API + "/pcp/GetGoals?clientId=" + _ClientId);
            const result = await res.json();
            setData(result);
            setdataLoaded(true);
            setLoading(false);
        }

        fetchData();
    }, []);

    useEffect(() => {
       
    const loadArrGoals=()=>{
            if (Data) {

            if (Data.length > 0) {
                for (let i = 0; i < Data.length; i++) {
                    if (Data[i].goaltype.GoalTypeName == "Social Goals") {
                        setdisableImportBtn(false);
                        setsocialAction (Data[i].Action);
                        if (Data[i].Goals.length > 0) {
                            for (let g = 0; g < Data[i].Goals.length; g++) {
                                
                                let goalname = Data[i].goaltype.GoalTypeName + (g + 1);
                                let goalText = Data[i].Goals[g].goalMasterData.GoalText;
                                setsocialGoals((socialGoals)=>([...socialGoals, {goalname,goalText}]));
                            }
                        }
                    }
                    //  Personal Goals
                    if (Data[i].goaltype.GoalTypeName == "Personal Goals") {
                        setdisableImportBtn(false);
                        setPersonalAction (Data[i].Action);
                        if (Data[i].Goals.length > 0) {
                             for (let g = 0; g < Data[i].Goals.length; g++) {
                                 let goalname = Data[i].goaltype.GoalTypeName + (g + 1);
                                 let goalText = Data[i].Goals[g].goalMasterData.GoalText;
                                setPersonalGoals((personalGoals)=>([...personalGoals, {goalname,goalText}]));
                            }
                        }
                    }

                    if (Data[i].goaltype.GoalTypeName == "Professional Goals") {
                        setdisableImportBtn(false);
                        setprofessionalAction (Data[i].Action);
                        if (Data[i].Goals.length > 0) {
                            for (let g = 0; g < Data[i].Goals.length; g++) {
                                let goalname = Data[i].goaltype.GoalTypeName + (g + 1);
                                let goalText = Data[i].Goals[g].goalMasterData.GoalText;
                                setprofessionalGoals((professionalGoals)=>([...professionalGoals, {goalname,goalText}]));
                            }
                        }
                    }


                    if (Data[i].goaltype.GoalTypeName == "Health and Safety Goals") {
                        setdisableImportBtn(false);
                        sethealthandSafetyAction (Data[i].Action);
                        if (Data[i].Goals.length > 0) {
                            for (let g = 0; g < Data[i].Goals.length; g++) {
                                 let goalname = Data[i].goaltype.GoalTypeName + (g + 1);
                                let goalText = Data[i].Goals[g].goalMasterData.GoalText;
                                sethealthandSafetyGoals((healthandSafetyGoals)=>([...healthandSafetyGoals, {goalname,goalText}]));
                            }
                        }
                    }


                }
               
            }
        }

        };

        loadArrGoals();
        if (Data && Data.length == 0) {
            setdisableImportBtn(true);
        }
        
},[Data]);

    const handleImportGoals = () => {
        let isSelectedGoals = false;
        if (selectedSocialGoals.length > 0) {
            isSelectedGoals = true;
            for (let g = 0; g < selectedSocialGoals.length; g++) {
                let goalText = selectedSocialGoals[g].goalText;
                const goal = {
                    Id: 0,
                    fkPCPGoalTypeId: 0,
                    fkGoalMasterDataId: 0,
                    goalMasterData: { Id: 0, GoalText: goalText }
                };
                dispatch({ type: IMPSOCIALGOALAction.AddSocialGoal, payload: goal });
            }
        }

         if (selectedpersonalGoals.length > 0) {
             isSelectedGoals = true;
            for (let g = 0; g < selectedpersonalGoals.length; g++) {
                let goalText = selectedpersonalGoals[g].goalText;
                const goal = {
                    Id: 0,
                    fkPCPGoalTypeId: 0,
                    fkGoalMasterDataId: 0,
                    goalMasterData: { Id: 0, GoalText: goalText }
                };
                dispatch({ type: IMPPERSONALGOALAction.AddPersonalGoal, payload: goal });
            }
        }

         if (selectedprofessionalGoals.length > 0) {
             isSelectedGoals = true;
            for (let g = 0; g < selectedprofessionalGoals.length; g++) {
                let goalText = selectedprofessionalGoals[g].goalText;
                const goal = {
                    Id: 0,
                    fkPCPGoalTypeId: 0,
                    fkGoalMasterDataId: 0,
                    goalMasterData: { Id: 0, GoalText: goalText }
                };
                dispatch({ type: IMPPROFESSIONALGOALAction.AddProfessionalGoal, payload: goal });
            }
        }
      
         if (selectedhealthandSafetyGoals.length > 0) {
             isSelectedGoals = true;
            for (let g = 0; g < selectedhealthandSafetyGoals.length; g++) {
                let goalText = selectedhealthandSafetyGoals[g].goalText;
                const goal = {
                    Id: 0,
                    fkPCPGoalTypeId: 0,
                    fkGoalMasterDataId: 0,
                    goalMasterData: { Id: 0, GoalText: goalText }
                };
                dispatch({ type: IMPHEALTHSAFEGOALAction.AddHealthSafeGoal, payload: goal });
            }
        }
        if (isSelectedGoals) {
            setSelectAll(a => !a);
            afterSave(socialAction, personalAction, professionalAction, healthandSafetyAction, selectedSocialGoals, selectedpersonalGoals, selectedprofessionalGoals, selectedhealthandSafetyGoals);
        } else {
            window.alert('Please select the goals', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            return false;
        }

}
const [checked,setchecked] = useState(false); 
const handleSelectAll =()=>{

}
//const [isSocialSelectedAll,setisSocialSelectedAll] = useState(false);
const [SelectedSocialGoalArr,setSelectedSocialArr] = useState([]);


const handleCheckboxClick = (goals,e) =>
{
    let chkBoxName = e.target.name; //goalname,goalText
    let goalname = e.target.id;
    let goalText =e.target.value;
    if(chkBoxName =="Social Goals")
    {
        if(e.target.checked){
            setselectedSocialGoals((selectedSocialGoals) => ([...selectedSocialGoals, { goalname, goalText }]));
            
        } else {
            let selectedgoalName = goalname;
            setselectedSocialGoals((selectedSocialGoals) => selectedSocialGoals.filter((item) => item.goalname !== selectedgoalName));
        }
        setSelectAll(a=>!a);
       
    }

     if(chkBoxName =="Personal Goals")
    {
        if(e.target.checked){
            setselectedpersonalGoals((selectedpersonalGoals) => ([...selectedpersonalGoals, { goalname, goalText }]));
        } else {
            let selectedgoalName = goalname;
            setselectedpersonalGoals((selectedpersonalGoals) => selectedpersonalGoals.filter((item) => item.goalname !== selectedgoalName));
        }
        setSelectAll(a=>!a);
    }
    if(chkBoxName =="Professional Goals")
    {
        if(e.target.checked){
            setselectedprofessionalGoals((selectedprofessionalGoals) => ([...selectedprofessionalGoals, { goalname, goalText }]));
        } else {
            let selectedgoalName = goalname;
            setselectedprofessionalGoals((selectedprofessionalGoals) => selectedprofessionalGoals.filter((item) => item.goalname !== selectedgoalName));
        }
        setSelectAll(a=>!a);
    }

    if(chkBoxName =="Health and Safety Goals")
    {
        if(e.target.checked){
            setselectedhealthandSafetyGoals((selectedhealthandSafetyGoals) => ([...selectedhealthandSafetyGoals, { goalname, goalText }]));
        } else {
            let selectedgoalName = goalname;
            setselectedhealthandSafetyGoals((selectedhealthandSafetyGoals) => selectedhealthandSafetyGoals.filter((item) => item.goalname !== selectedgoalName));
        }
        setSelectAll(a=>!a);
    }
        setCheckedValue(chkBoxName,goalname);
        
        checkisSelectedAll(chkBoxName);

}
 
const checkSelectAll = (e) =>{
   
    let checkBoxName = e.target.name;
    if(checkBoxName =="Social Goals"){
        if(e.target.checked)
        {  
            setselectedSocialGoals(socialGoals);
            setSelectAll(a=>!a);
        }else
        {
            setselectedSocialGoals([]);
            setSelectAll(a=>!a);
        }
    }

    if(checkBoxName =="Personal Goals"){
        if(e.target.checked)
        {  
            setselectedpersonalGoals(personalGoals);
            setSelectAll(a=>!a);
        }else
        {
            setselectedpersonalGoals([]);
            setSelectAll(a=>!a);
        }
    }

    if(checkBoxName =="Professional Goals"){
        if(e.target.checked)
        {  
            setselectedprofessionalGoals(professionalGoals);
            setSelectAll(a=>!a);
        }else
        {
            setselectedprofessionalGoals([]);
            setSelectAll(a=>!a);
        }
    }
    if(checkBoxName =="Health and Safety Goals"){
        if(e.target.checked)
        {  
            setselectedhealthandSafetyGoals(healthandSafetyGoals);
            setSelectAll(a=>!a);
        }else
        {
            setselectedhealthandSafetyGoals([]);
            setSelectAll(a=>!a);
        }
    }


}

const checkisSelectedAll = (goalType) =>{
    if(goalType =="Social Goals"){
        if( selectedSocialGoals.length>0 && selectedSocialGoals.length == socialGoals.length){
        return true;
        }else{
        return false;
        }
    }

    //
     if(goalType =="Personal Goals"){
        if( selectedpersonalGoals.length >0 && selectedpersonalGoals.length == personalGoals.length){
        return true;
        }else{
        return false;
        }
    }

     //
     if(goalType =="Professional Goals"){
        if(selectedprofessionalGoals.length > 0 && selectedprofessionalGoals.length == professionalGoals.length){
        return true;
        }else{
        return false;
        }
    }

     if(goalType =="Health and Safety Goals"){
        if(selectedhealthandSafetyGoals.length > 0 && selectedhealthandSafetyGoals.length == healthandSafetyGoals.length){
        return true;
        }else{
        return false;
        }
    }

}
  const setCheckedValue =(goalName,id)=>{
    if(goalName=="Social Goals")
    {
        return selectedSocialGoals.some(item=>item.goalname == id);
      
    }

     if(goalName=="Personal Goals")
    {
        return selectedpersonalGoals.some(item=>item.goalname == id);
      
    }

      if(goalName=="Professional Goals")
    {
        return selectedprofessionalGoals.some(item=>item.goalname == id);
      
    }

    if(goalName=="Health and Safety Goals")
    {
        return selectedhealthandSafetyGoals.some(item=>item.goalname == id);
      
    }
    return true;
  }
  const [isOverride,setisOverride] = useState(false);
const handleOverride = ()=>{
setisOverride(a=>!a);

}
    return (
       <Form >
                
            <Row className="mb-6">
                 <Col md={6}>
              </Col>
              
              <Col md={3}>
              </Col>
               <Col md={1}>
              </Col>
                <Col md={2}>
                    <Button onClick={handleImportGoals} style={{ align: 'right' }} disabled={disableImportBtn}  variant='primary'>Import goals</Button>
                </Col>

            </Row>
        
            <Row className="mb-6">
                <Card>
                    <Card.Body>
                       <Row className='mb-2'>
                        {loading && <div className="d-flex justify-content-center align-items-top" style={{ height: "10vh" }}>
  <Spinner animation="border" variant="primary" />
</div>}                    
                             
                        {Data !=null && Data.length>0 && Data.map((dat=>(
                           <Row className="border border-1 border-primary">
                                <Col>{dat.goaltype.GoalTypeName} </Col>
                                 <Col><Row>
                                     <Col style={{  color: 'black',  padding: '1px'}}>
                                         <Form.Check type="checkbox" 
                                         id={dat.goaltype.GoalTypeName} 
                                         name={dat.goaltype.GoalTypeName} 
                                        value="Select All" label="Select All" 
                                        checked={checkisSelectedAll(dat.goaltype.GoalTypeName)}
                                        onChange={(e)=>checkSelectAll(e)}  />
                                   </Col>
                                 </Row>
                                    {dat.Goals.map((goal,index)=>(
                                        
                                    <Row className='mb-2'>
                                       
                                        <Col style={{ backgroundColor: '#ffcc00', color: 'black',  padding: '1px'}}>
                                         <Form.Check type="checkbox" key={index}
                                          name={dat.goaltype.GoalTypeName} 
                                          id={dat.goaltype.GoalTypeName+(index+1)}
                                          value={goal.goalMasterData.GoalText} 
                                          label = {goal.goalMasterData.GoalText.length>50 ? goal.goalMasterData.GoalText.substring(0,50):goal.goalMasterData.GoalText}
                                          checked={setCheckedValue(dat.goaltype.GoalTypeName,dat.goaltype.GoalTypeName+(index+1))}
                                          onChange={(e)=>handleCheckboxClick(goal,e)} />
                                            {/* {goal.goalMasterData.GoalText.length>20 ? goal.goalMasterData.GoalText.substring(0,20):goal.goalMasterData.GoalText}  */}
                                            {/* </Form.Check>  */}
                                        </Col>
                                    </Row>
                                 ))}</Col>
                            </Row>
                        )))} 

                        
                        
                       {!loading && Data.length==0 &&
                       <div className="mb-2">
                         <Row className="p-2 text-center border">
                             <Col>
                                <b>No goals found</b>
                             </Col>
                        </Row>
                        </div>
                       }
                                             
                       </Row>
                    </Card.Body>
                </Card>
            </Row>
        </Form>
    )
}
